import { render, staticRenderFns } from "./addCodebookCategory.vue?vue&type=template&id=ebe5abe4&scoped=true&lang=html&"
import script from "./addCodebookCategory.vue?vue&type=script&lang=js&"
export * from "./addCodebookCategory.vue?vue&type=script&lang=js&"
import style0 from "./addCodebookCategory.vue?vue&type=style&index=0&id=ebe5abe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe5abe4",
  null
  
)

export default component.exports